// Where the collapsed "Ask Phanova AI" pill sits. FloatingChat positions the
// pill from these values, and layouts that would otherwise slide under it
// (the Smart Hub rail, the patient-list table, the bottom of every page)
// reserve room from the same numbers. Kept in a leaf module so those layouts
// don't import the chat itself.

export const MOBILE_BREAKPOINT = 600;
export const PILL_BOTTOM = 24;
export const PILL_HEIGHT = 52;
const PILL_GAP = 12;

// Vertical space to keep clear at the bottom of the viewport so the closed
// pill never covers content: its offset, its height and a small gap above it.
export const FLOATING_CHAT_CLEARANCE = PILL_BOTTOM + PILL_HEIGHT + PILL_GAP;

// Body class FloatingChat sets while it is mounted; index.css pads the page
// bottom by FLOATING_CHAT_CLEARANCE under it.
export const FLOATING_CHAT_BODY_CLASS = 'has-floating-chat';

// Width matches the Smart Hub column, derived from the Dashboard wrapper
// geometry: maxWidth 1536, paddingX 24 each side, Flex gap 16, ratios 3:1 →
// right column = (min(100vw, 1536) − 48 − 16) / 4.
export const RAIL_COLUMN_WIDTH = 'calc((min(100vw, 1536px) - 64px) / 4)';

// Right offset hugs the Dashboard wrapper's right edge: 24px when the
// viewport is ≤ 1536, otherwise (viewport - 1536)/2 + 24 (centered wrapper).
export const RAIL_RIGHT_OFFSET = 'max(24px, calc((100vw - 1536px) / 2 + 24px))';

// The collapsed pill's box in viewport pixels — the CSS above, evaluated.
export function collapsedPillRect(
  viewportWidth: number,
  viewportHeight: number,
): { left: number; right: number; top: number; bottom: number } {
  const rightOffset = Math.max(24, (viewportWidth - 1536) / 2 + 24);
  const width =
    viewportWidth < MOBILE_BREAKPOINT
      ? viewportWidth - 32
      : (Math.min(viewportWidth, 1536) - 64) / 4;
  const right = viewportWidth - rightOffset;
  const bottom = viewportHeight - PILL_BOTTOM;
  return { left: right - width, right, top: bottom - PILL_HEIGHT, bottom };
}
